export default "__VITE_ASSET__C2bsv18I__"